import { hasFlag } from "country-flag-icons";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import countries from "i18n-iso-countries";
import english from "i18n-iso-countries/langs/en.json";

countries.registerLocale(english);

/**
 * Flag for a timezone, preferring an explicit country code when the caller has one.
 *
 * The zone's first segment is a continent for most of the world ("Europe/Zurich", "America/New_York"),
 * so deriving a country from it only ever worked for "Australia/…". The old `|| "au"` fallback then
 * showed an Australian flag for every GB, CH and US profile. No fallback now: no country, no flag.
 */
export const getTimezoneFlag = (timezone: string, countryCode?: string) => {
  const code = countryCode?.toLowerCase() || countries.getAlpha2Code(timezone.split("/")[0], "en");
  if (code && hasFlag(code)) return getUnicodeFlagIcon(code);
  return undefined;
};
